import React from 'react';

function Content({ name, children }){
  return <div>
          <h1 className="px-2 mb-3 mt-6 bg-gray-50 pt-4 text-gray-600 pb-2 shadow">
            {name}
          </h1>
          <div className="space-y-8">
            {children}
          </div>
          </div>
}

function Head({ prefix, name, params, description, children }){
  return <div className="">
          <div className="font-mono bg-gray-100 px-2 py-2 border-t-2 border-blue-700">
            {prefix? <span className="mr-2 text-gray-500">{prefix}</span>: null}
            {name}
            ({(params.map((d,i)=>
              <span className="text-gray-500" key={i}><span className="text-blue-700">{d.name}</span>{d.type? ": ":""}<span className="text-gray-500">{d.type}</span>{d.default? ` = ${d.default}`: ""}{i===params.length-1? "": ", "}</span>))})
          </div>
          <div className="text-gray-500 mt-2 text-lg">
            {description}
            {children}
          </div>
          </div>
}

function Params({ params }){
  return <div>
          <h3 >Parameters</h3>
          <table>
            <thead>
              <tr><th>Property</th><th>Type</th><th>Default</th><th>Description</th></tr>
            </thead>
            <tbody>
            {params.map(d=>
              <tr key={d.name}>
                <td><code>{d.name}</code></td>
                <td><code className="text-pink-600">{d.type}</code></td>
                <td><code>{d.default || "-"}</code></td>
                <td dangerouslySetInnerHTML={{ __html: d.description }}></td>
              </tr>)}
            </tbody>
          </table>
          </div>
}

const PythonDoc = {}
PythonDoc.Head = Head;
PythonDoc.Params = Params;
PythonDoc.Content = Content;
export { PythonDoc };
